import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this.element.setAttribute("autocomplete", "none")

    const config = {
      valueField: "id",
      labelField: "name",
      searchField: ["id", "name", "full_address"],
      selectOnTab: true,
      openOnFocus: true,
      placeholder: "Start typing to search for a company...",
      maxItems: 1,
      closeAfterSelect: true,
      load: this.loadOptions,
      render: {
        option: this.renderOption,
        item: this.renderItem
      }
    }

    new TomSelect(this.element, config)
  }

  renderItem(company, escape) {
    return `
    <div>${escape(company.id)} - ${escape(company.name)}</div>`
  }

  renderOption(company, escape) {
    return `
    <div>
      ${escape(company.id)} - ${escape(company.name)} <small><i>${escape(company.full_address)}</i><small>
    </div> `
  }

  loadOptions(query, callback) {
    const url = `${this.input.dataset.url}?search=${encodeURIComponent(query)} `

    fetch(url)
      .then(response => response.json())
      .then(json => {
        callback(json)
      }).catch(() => {
        callback()
      })
  }
}


